(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    var $rail = $('#rightRail');
    if (!$rail.length) return;

    var $container = $('.t-single-post-content');
    if (!$container.length) return;

    var $items = $rail.find('.t-single-post-right-rail-item');
    var $slider = $rail.find('.t-single-post-right-rail-slider');
    var $prev = $rail.find('.t-single-post-right-rail-btn-prev');
    var $next = $rail.find('.t-single-post-right-rail-btn-next');
    var $counter = $rail.find('.t-single-post-right-rail-counter');
    var $toggle = $rail.find('.t-single-post-right-rail-tab .drawer-cta__toggle');

    var count = $items.length;
    var index = 0;

    function clampIndex(i) {
      if (count <= 0) return 0;
      if (i < 0) return count - 1;
      if (i >= count) return 0;
      return i;
    }

    function renderSlider() {
      if (!count) return;
      $items.each(function (i) {
        if (i === index) {
          $(this).removeAttr('hidden');
        } else {
          $(this).attr('hidden', 'hidden');
        }
      });
      $slider.attr('data-index', String(index));

      if ($counter.length) {
        $counter.text(String(index + 1) + '/' + String(count));
      }

      if (count <= 1) {
        $prev.attr('disabled', 'disabled');
        $next.attr('disabled', 'disabled');
      }
    }

    $prev.on('click', function () {
      index = clampIndex(index - 1);
      renderSlider();
    });

    $next.on('click', function () {
      index = clampIndex(index + 1);
      renderSlider();
    });

    renderSlider();

    var isCollapsed = $rail.hasClass('is-collapsed');

    function setCollapsed(nextCollapsed) {
      isCollapsed = !!nextCollapsed;
      $rail.toggleClass('is-collapsed', isCollapsed);
      if ($toggle.length) {
        $toggle.attr('aria-expanded', String(!isCollapsed));
        $toggle.attr('aria-label', isCollapsed ? 'Expand related reading' : 'Collapse related reading');
      }
    }

    if ($toggle.length) {
      $toggle.on('click', function (e) {
        e.preventDefault();
        setCollapsed(!isCollapsed);
      });
      setCollapsed(isCollapsed);
    }

    var ticking = false;

    function setVisible(isVisible) {
      if (isVisible) {
        $rail.addClass('is-visible');
        $rail.attr('aria-hidden', 'false');
      } else {
        $rail.removeClass('is-visible');
        $rail.attr('aria-hidden', 'true');
      }
    }

    function updateRail() {
      ticking = false;

      var containerTop = $container.offset().top;
      var containerHeight = $container.outerHeight();
      var containerBottom = containerTop + containerHeight;

      var revealPoint = containerTop + containerHeight * 0.05;
      var hidePoint = containerBottom - 400;

      var scrollTop = $(window).scrollTop();

      var shouldShow = scrollTop >= revealPoint && scrollTop <= hidePoint;
      setVisible(shouldShow);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateRail);
      }
    }

    $(window).on('scroll', onScroll);
    $(window).on('resize orientationchange', onScroll);

    // Initial state
    updateRail();
  });
});

},{}]},{},[1]);
